// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610190633/js/" + chunkId + "." + {"44":"1eef0f1f","225":"a4cdf686","481":"13963bb3","486":"3b8f5e72","770":"214d4b49"}[chunkId] + ".0.883698483783007.chunk.js";
};